function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "#2C3137"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.847 2.847v11.306h11.306V2.847H2.847zm11.306 0h1.714v11.306h-1.714v1.714H2.847v-1.714H1.133V2.847h1.714V1.133h11.306v1.714z",
  fillOpacity: 0.85
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.333 3H3V1.333H1.333V3zM0 1a1 1 0 011-1h2.334a1 1 0 011 1v2.334a1 1 0 01-1 1H1a1 1 0 01-.999-1V1zm14 2h1.667V1.333H14V3zm-1.333-2a1 1 0 01.999-1H16A1 1 0 0117 1v2.334a1 1 0 01-1 1h-2.334a1 1 0 01-1-1V1zM14 15.666h1.667V14H14v1.667zm-1.333-2.001a1 1 0 01.999-1H16a1 1 0 01.999 1V16A1 1 0 0116 17h-2.334a1 1 0 01-1-1v-2.334zm-11.334 2H3V14H1.333v1.667zm-1.333-2a1 1 0 011-1h2.334a1 1 0 011 1V16a1 1 0 01-1 .999H1A1 1 0 010 16v-2.334z"
}));

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 17"
  }, props), _ref);
};

export default SvgComponent;